import Backend from "./Backend"

export default class ProductStore {
    static products = []

    static setProducts(productArray = []) {
        if (Array.isArray(productArray)) {
            ProductStore.products = productArray
        }
    }

    static addProducts(productArray = []) {
        if (Array.isArray(productArray)) {
            const idMap = productArray.reduce((obj, product) => {
                obj[product.campaignProductId] = true
                return obj
            }, {})

            const filteredProducts = ProductStore.products.filter((product) => !idMap[product.campaignProductId])
            productArray.forEach((product) => {
                filteredProducts.push(product)
            })
            ProductStore.products = filteredProducts
        }
        return ProductStore.products
    }

    static sortPorductsByIds(commaSeparatedSequence = "", arrayCollection = []) {
        const sequenceArray = commaSeparatedSequence.split(",");
        const lookup = new Map(arrayCollection.map(item => [item.campaignProductId.toString(), item]));
        return sequenceArray.map(id => lookup.get(id)).filter(Boolean);
    }

    static async fetchPageProducts(data) {
        try {
            const pageProductIds = ProductStore.getPageProductIds(data);
            if (pageProductIds) {
                const data = await Backend.getProducts(pageProductIds, true)
                ProductStore.addProducts(data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    static checkAndReturnProductsAndMissingIds(ids) {
        const idSplit = ids?.split(",") || []
        const response = {
            missingProductIds: ids,
            missingProductIdsCount: idSplit.length,
            productsFound: []
        }
        if (idSplit.length) {
            const idMap = idSplit.reduce((obj, id) => {
                if (id) {
                    obj[id] = true
                }
                return obj
            }, {})
            const productsFound = []
            ProductStore.products.forEach((product) => {
                const productId = product.campaignProductId
                if (idMap[productId]) {
                    productsFound.push(product)
                    idMap[productId] = false
                }
            })
            const missingProductIds = []
            for (let id in idMap) {
                if (idMap[id]) {
                    missingProductIds.push(id)
                }
            }
            response.productsFound = productsFound
            response.missingProductIds = missingProductIds.join(",")
            response.missingProductIdsCount = missingProductIds.length
        }
        return response
    } 

    static getPageProductIds(data) {
        try {
            const currentLocation = window.location.href
            const productIds = new Set();
            // Cart products
            const localCart = JSON.parse(localStorage.getItem("cart") || "{}")
            const localCartItems = localCart?.items || []
            localCartItems.forEach((item) => {
              const id = item?.product?.campaignProductId, recurrId = item?.product?.recurringProductId;
              if (id) {
                productIds.add(id.toString())
              }
              if (recurrId) {
                productIds.add(recurrId.toString())
              }
            })
            // Page blocks
            const blocks = data?.page?.content_blocks || []
            blocks.forEach((block) => {
              if (block.block_id === 39) {
                const selectedProducts = block?.extra?.selected_products || []
                selectedProducts.forEach((item) => {
                  productIds.add(item.productId.toString())
                })
              } else if (block.block_id === 37) {
                const id = block?.extra?.featured_product?.productId
                if (id) {
                  productIds.add(id.toString())
                }
              }
            })
            // Product page
            const productPageSlug = data?.website?.product_page_slug || "shop/product"
            const isProductPage = currentLocation?.match(new RegExp("/" + productPageSlug + "/" + "(\\d+)"))
            if (isProductPage) {
              productIds.add(isProductPage[1].toString())
            }
            // cart recommendation products
            const recommendationProducts = data?.website?.extra?.cart_settings?.cart_recommendation_products || []
            recommendationProducts.forEach((item) => {
              productIds.add(item.productId.toString())
            })
            // popup products
            const popupData = data?.website?.extra?.popup_collection || []
            popupData.forEach((popup) => {
              const layoutData = popup?.layout || []
              layoutData.forEach((block) => {
                if (block?.action === "addtocartmoredetails" && block?.productData?.value) {
                  productIds.add(block.productData.value.toString())
                }
              })
            })
            // cart page order bump
            const cartPageSlug = data?.website?.cart_page_slug || "shop/cart"
            const isCartPage = currentLocation?.match(new RegExp("/" + cartPageSlug))
            const cartPageOrderBumpId = isCartPage && data?.website?.extra?.product_page_settings?.cart_page_product?.productId
            if (cartPageOrderBumpId) {
              productIds.add(cartPageOrderBumpId.toString())
            }
            return Array.from(productIds)
        } catch (error) {
            return []
        }
    }
}
